// import React, { useEffect, useState } from "react";
// import { useAuthContext } from "../context/AuthContext";

// const Notification = () => {
//   const { notificationData, handleNotification } = useAuthContext();
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (notificationData?.message) {
//       setVisible(true);

//       const timer = setTimeout(() => {
//         setVisible(false);
//         handleNotification(null, "");
//       }, 9000);

//       return () => clearTimeout(timer);
//     }
//   }, [notificationData]);

//   if (!visible) {
//     return null;
//   }

//   return (
//     <div
//       className="w-[94%] lg:w-[25%] h-fit bg-textPrimaryColor rounded-xl shadow p-[3%] lg:p-[1%] fixed right-[3%] bottom-[5%] animate-slideRightToLeft"
//       style={{ zIndex: 999 }}
//     >
//       <p className="font-normal text-[4vw] lg:text-[1vw] text-whiteColor text-center">
//         {notificationData?.message}
//       </p>
//     </div>
//   );
// };

// export default Notification;





import React, { useEffect, useState } from "react";
import { useAuthContext } from "../context/AuthContext";

const Notification = () => {
  const { notificationData, handleNotification } = useAuthContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (notificationData?.message) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
        handleNotification(null, "");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [notificationData]);

  if (!visible) return null;

  // Default position: bottom-right
  let positionClasses = "fixed right-[3%] bottom-[5%]";
  
  if (notificationData?.position === "center") {
    positionClasses = "fixed left-1/2 top-[20%] transform -translate-x-1/2";
  } else if (notificationData?.position === "bottom-left") {
    positionClasses = "fixed left-[3%] bottom-[5%]";
  }

  return (
    <div
      className={`w-[94%] lg:w-[25%] h-fit bg-textPrimaryColor rounded-xl shadow p-[3%] lg:p-[1%] ${positionClasses} animate-slideRightToLeft`}
      style={{ zIndex: 999 }}
    >
      <p className="font-normal text-[4vw] lg:text-[1vw] text-whiteColor text-center">
        {notificationData?.message}
      </p>
    </div>
  );
};

export default Notification;
